const spanishTranslation = {
    translation:{
        "en": "INGLES",
        "sp": "ESPAÑOL",
        "jp": "JAPONÉS",
        "brand": "DIEGO",
        "about": "ACERCA",
        "experience": "EXPERIENCIA",
        "projects": "PROYECTOS",
        "contact": "CONTACTO",
        "hire": "CONTRATAR",
        "carrier": "INGENIERO DE SOFTWARE",
        "cv": "DESCARGAR CV",
        "cv-pdf": "./assets/docs/BTDF_CV_ENG.pdf",
        "salutate": 'Hola, Yo soy',
        "full-name": 'Diego Fernando Trenado',
        "goal": 'oy Desarrollador Full Stack, Maker y Ingeniero en Sistemas Computacionales con sede en México. Me apasiona diseñar, desarrollar y optimizar aplicaciones web. Actualmente, estoy construyendo productos escalables y confiables utilizando varios servicios de la nube, y mejorando la estética, el rendimiento y la funcionalidad de aplicaciones en varios proyectos.',
        "about-title": "Acerca de mi",
        "about-me-1": 'Hola mi nombre es Diego y soy un apasionado por la programación y el diseño. Comencé a desarrollar productos para la web desde el año 2017 como un hoby.',
        "about-me-2": 'He tenido la oportunidad de estar en diversas empresas para aprender y mejorar mis habilidades. Soy una persona orientada a resultados que siempre trata de conseguir las mejores soluciones para cada proyecto.',
        "about-me-3": 'Estas son algunas de las tecnologias con las que trabajo hoy en dia.',
        "about-me": "test",
      
        "tech-stack": "TECNOLOGíAS QUE USO",
        "contact-me": "CONTACTO",
        "email": "Correo",
        "name": "Nombre",
        "message": "Mensaje",
        "send": "ENVIAR",
        "reset": "REINICIAR",
        "developed": "Desarrollado",

        "recent-projects": "PROYECTOS RECIENTES",

        "name-project-1": "Encárgamelo. Pedidos en línea para restaurantes",
        "tech-project-1": "Firebase, Cloud Firestone, React, Tailwind CSS",
        "description-project-1": "plataforma de pedidos en línea que permite a los restaurantes gestionar y publicar sus menús, y a los clientes hacer pedidos directamente en la página de menú específica del restaurante.",
        "img-project-1": "/assets/images/projects/encargamelo.png",
        "github-project-1": "https://github.com/SakugaCoder/Automotive-parts-detection",

        "name-project-2": "Gestor de documentos empresariales",
        "tech-project-2": "Python, Flask, MySQL, Ubuntu Server, React, Styled-Components",
        "description-project-2": "Plataforma web para administrar documentos empresariales, con un sistema de roles y permisos, y un panel de control para la administración de usuarios y documentos.",
        "img-project-2": "/assets/images/projects/Dashboard.jpg",
        "github-project-2": "https://github.com/SakugaCoder/GloveController",

        "name-project-3": "AI chatbot para ventas de llantas",
        "tech-project-3": "Lambda, API Gateway, Facebok Cloud API, OpenAI Assistant API, Python",
        "description-project-3": "Asistente basado en WhatsApp para gestionar y promover la venta de llantas, utilizando arquitectura Serverless, la API de OpenAI Assistant y la API de Facebook Cloud.",
        "img-project-3": "/assets/images/projects/chat.png",
        "github-project-3": "https://github.com/SakugaCoder/ThingsToBuy-ReactJS"
  }
};

export default spanishTranslation;